<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/industry-manage' }"
          >行业监管</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div
        class="articleContent-context"
        style="
          border-radius: 4px;
          border: 1px solid #e6ebf5;
          padding: 20px 20px 10px;
        "
      >
        <div class="grid-content bg-purple-dark">
          <p>{{ regulations.laws }}</p>
          <div class="hxl_title"></div>
        </div>
        <div class="announcement">
          <div class="frame">
            <el-button
              style="font-size: 16px"
              @click="all()"
              :type="regulations.lawAll"
              >所有</el-button
            >
            <el-button
              style="font-size: 16px"
              @click="reg()"
              :type="regulations.lawRegulations"
              >法律、行政法规</el-button
            >
            <el-button
              style="font-size: 16px"
              @click="file()"
              :type="regulations.lawFile"
              >规范性文件</el-button
            >
            <el-button
              style="font-size: 16px"
              @click="department()"
              :type="regulations.lawDepartment"
              >部门规章</el-button
            >
            <el-button
              style="font-size: 16px"
              @click="covenant()"
              :type="regulations.lawCovenant"
              >国际公约</el-button
            >
            <el-button
              style="font-size: 16px"
              @click="reference()"
              :type="regulations.lawReference"
              >参考</el-button
            >
          </div>
          <div class="ipt">
            <el-input
              style="width: 41%; height: auto; font-size: 14px"
              v-model="searchOn"
              maxlength="24rem"
              placeholder="标题/正文/文号"
              class="input-with-select"
            >
              <el-button
                style="font-size: 16px"
                slot="append"
                size="small"
                @click="seeSer()"
                >搜索</el-button
              >
            </el-input>
            <el-button
              style="
                margin-left: 5px;
                background-color: transparent;
                height: auto;
                font-size: 16px;
              "
              size="small"
              class="reset"
              @click="resetOn()"
              >重置</el-button
            >
          </div>
          <div class="dat">
            <div class="paging">
              <span style="font-size: 16px; margin-right: 4px">发布日期</span>
              <!-- <el-select v-model="data" placeholder="请选择" style="width: 130px;">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                >
                </el-option>
              </el-select> -->

              <el-date-picker
                popper-class="timeclass"
                v-model="timeSta"
                type="date"
                placeholder="开始时间"
                @change="timeStaChange()"
              >
              </el-date-picker>
              <span style="font-size: 16px; margin-left: 5px">至</span>
              <el-date-picker
                popper-class="timeclass"
                v-model="timeEnd"
                type="date"
                placeholder="结束时间"
                @change="timeEndChange()"
              >
              </el-date-picker>
            </div>
            <div>
              <el-button
                style="font-size: 16px"
                size="small"
                icon="el-icon-refresh"
                class="refresh"
                @click="refresh()"
                >刷新</el-button
              >
            </div>
          </div>
          <div style="text-align: center; margin-top: 5px">
            <el-table
              :data="legalForms"
              :stripe="true"
              @cell-click="handle"
              border
              fit
              style="width: 100%"
              :header-cell-style="{
                background: '#ebe6db',
                color: '#585856',
                borderColor: '#585856',
                fontSize: '12px',
                padding: '4px 0 !important',
              }"
              :cell-style="{ borderColor: '#585856' }"
            >
              <el-table-column
                align="center"
                type="index"
                :index="count"
                label="序号"
                width="60"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="article_title"
                label="标题"
                min-width="316px"
              >
                <template slot-scope="scope"
                  >             
                  <router-link
                    :to="{
                      path: '/home/gov-info-disclosure',
                      query: {
                        id: scope.row.article_id,
                        type: scope.row.legal_type,
                      },
                    }"
                    style="
                      color: #606266;
                      text-decoration: underline;
                      font-size: 16px;
                    "
                    >{{ scope.row.article_title }}</router-link
                  >
                               
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="dispatch_number"
                label="发文字号"
                min-width="158px"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="legal_type"
                label="类型"
                min-width="158px"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="publish_time"
                label="发布日期"
                min-width="158px"
              >
                <template slot-scope="scope">{{
                  scope.row.publish_time | formatDate
                }}</template>
              </el-table-column>
              <!-- <el-table-column
                      align="center"
                      prop="written_time"
                      label="成文日期"
                      min-width="158px"
              >
                <template slot-scope="scope">{{
                  scope.row.written_time | formatDate
                  }}</template>
              </el-table-column> -->
              <el-table-column
                align="center"
                prop="source_name"
                label="发文机构"
                min-width="158px"
              >
              </el-table-column>
            </el-table>
            <el-pagination
              popper-class="pageclass"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 40, 80]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import { URL_LAWS_FIND } from "../../utils/api";
import util from "../../utils/util";
import { frontHeater } from "../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "法律法规",
        // 所有
        lawAll: "danger",
        // 法律、行政法规
        lawRegulations: "success",
        // 规范性文件
        lawFile: "success",
        // 部门规章
        lawDepartment: "success",
        // 国际公约
        lawCovenant: "success",
        // 参考
        lawReference: "success",
      },
      //   下拉列表
      options: [
        {
          value: "发布日期",
          label: "发布日期",
        },
        // {
        //   value: "成文日期",
        //   label: "成文日期",
        // },
      ],
      numerical: null,
      //  选择框model
      data: "发布日期",
      //   开始时间
      timeSta: "",
      // 结束时间
      timeEnd: "",
      //   搜索
      searchOn: null,
      // 法律法规 表格
      legalForms: [],
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 0,
      pagesize: 20,
      a: "1",
    };
  },
  computed: {},
  filters: {
    formatDate: function (value) {
      if (value != undefined) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "年" + MM + "月" + d + "日";
      }
    },
  },
  mounted() {
    this.getList();
  },
  updated() {},
  methods: {
    _formatDate(time) {
      if (time === null) return "";
      let date = new Date(time); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let m = date.getMonth() + 1,
        mm = m < 10 ? "0" + m : m;
      let d = date.getDate(),
        dd = d < 10 ? "0" + d : d;
      let h = date.getHours(),
        hh = h < 10 ? "0" + h : h;
      let i = date.getMinutes(),
        ii = i < 10 ? "0" + i : i;
      let s = date.getSeconds(),
        ss = s < 10 ? "0" + s : s;
      return (
        date.getFullYear() +
        "-" +
        mm +
        "-" +
        dd +
        "  " +
        hh +
        ":" +
        ii +
        ":" +
        ss
      );
    },
    // 请求表格数据
    async getList() {
      let Url = util.getAjaxUrl("axiosThree");
      let params;
      if (this.data == "发布日期") {
        let result = await frontHeater([""], [""]);
        if (this.timeSta !== "") {
          this.timeSta = this._formatDate(this.timeSta);
        }
        if (this.timeEnd == "") {
          var timeEnd = "";
        } else {
          var timeEnd = this._formatDate(this.timeEnd);
        }
        params = {
          keyWord: this.searchOn,
          legalType: this.numerical,
          publish_dateS: this.timeSta,
          publish_dateE: timeEnd,
          pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
        };
        this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
        this.$http.defaults.headers.common["secretSign"] =
          result.encryptionString;
        this.$http.defaults.headers.common["secretDefinite"] =
          result.parameterKey;
        this.$http.defaults.headers.common["appCode"] = result.secret;
        this.$http.post(Url + URL_LAWS_FIND, params).then((res) => {
          if (res.status == 200) {
            this.legalForms = res.data.data.data;
            this.total = res.data.data.pagination.totalNum;
          }
        });
      } else {
        let result = await frontHeater([""], [""]);
        params = {
          keyWord: this.searchOn,
          written_dateS: this.timeSta,
          written_dateE: this.timeEnd,
          pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
        };
        this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
        this.$http.defaults.headers.common["secretSign"] =
          result.encryptionString;
        this.$http.defaults.headers.common["secretDefinite"] =
          result.parameterKey;
        this.$http.defaults.headers.common["appCode"] = result.secret;
        this.$http.post(Url + URL_LAWS_FIND, params).then((res) => {
          if (res.status == 200) {
            this.legalForms = res.data.data.data;
            this.total = res.data.data.recordsTotal;
            frontHeater([1, 2, 2, 2, 2, 2, 2], [this.superviseSame, 2, 3]);
          }
        });
      }
    },
    handle(row) {
      this.a = row.title;
    },
    timeStaChange() {
      this.getList();
    },
    timeEndChange() {
      this.getList();
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },

    //   所有
    all() {
      this.regulations.lawAll = "danger";
      this.regulations.lawRegulations = "success";
      this.regulations.lawFile = "success";
      this.regulations.lawDepartment = "success";
      this.regulations.lawCovenant = "success";
      this.regulations.lawReference = "success";
      this.numerical = null;
      this.getList();
    },
    // 法律、行政法规
    reg() {
      this.regulations.lawAll = "success";
      this.regulations.lawRegulations = "danger";
      this.regulations.lawFile = "success";
      this.regulations.lawDepartment = "success";
      this.regulations.lawCovenant = "success";
      this.regulations.lawReference = "success";
      this.numerical = "法律、行政法规";
      this.getList();
    },
    // 规范性文件
    file() {
      this.regulations.lawAll = "success";
      this.regulations.lawRegulations = "success";
      this.regulations.lawFile = "danger";
      this.regulations.lawDepartment = "success";
      this.regulations.lawCovenant = "success";
      this.regulations.lawReference = "success";
      this.numerical = "规范性文件";
      this.getList();
    },
    // 部门规章
    department() {
      this.regulations.lawAll = "success";
      this.regulations.lawRegulations = "success";
      this.regulations.lawFile = "success";
      this.regulations.lawDepartment = "danger";
      this.regulations.lawCovenant = "success";
      this.regulations.lawReference = "success";
      this.numerical = "部门规章";
      this.getList();
    },
    // 国际公约
    covenant() {
      this.regulations.lawAll = "success";
      this.regulations.lawRegulations = "success";
      this.regulations.lawFile = "success";
      this.regulations.lawDepartment = "success";
      this.regulations.lawCovenant = "danger";
      this.regulations.lawReference = "success";
      this.numerical = "国际公约";
      this.getList();
    },
    // 参考
    reference() {
      this.regulations.lawAll = "success";
      this.regulations.lawRegulations = "success";
      this.regulations.lawFile = "success";
      this.regulations.lawDepartment = "success";
      this.regulations.lawCovenant = "success";
      this.regulations.lawReference = "danger";
      this.numerical = "参考";
      this.getList();
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.data = "发布日期";
      this.timeSta = null;
      this.timeEnd = null;
      this.searchOn = null;
      this.currentPage = 1;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 确定页数
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/theme";
@import "../../styles/comSty";
/deep/ .el-breadcrumb {
  margin-top: -10px;
  margin-bottom: 10px;
  font-size: 16px;
}
/deep/ .announcement {
  border: none;
}
.articleContent {
  padding: 20px;
}
p {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
/deep/.el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 16px;
}
/deep/.el-input__icon {
  line-height: 30px;
}
/deep/.paging .el-input {
  font-size: 12px;
  width: 150px;
  padding-left: 5px;
}
/deep/ .el-select .el-input {
  width: 130px !important;
}
.dat {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  /*padding: 0 20px;*/
}
.refresh {
  border-radius: 3px;
  height: 100%;
  box-sizing: border-box;
  color: @title-color;
  border-color: @border-color;
}
.ipt {
  margin-top: 10px;
  line-height: normal;
}
.frame {
  height: auto;
  line-height: normal;
  margin-top: 10px;
}
.reset {
  padding: 9px 15px !important;
}
.refresh {
  background-color: transparent;
}
.refresh:hover {
  color: @theme-color;
  border-color: @theme-color;
}
/deep/ .el-select {
  .el-input {
    width: 100px;
  }
}
a:hover {
  color: #b71c1c !important;
}
</style>
